import React, { Component } from 'react';
import App from './panel';

import Provider from './components/Provider';

const settings = {
    type:'sync',
    // updateStrategy:'immediate',
};
export default class extends Component {

    render() {
        return (
            <Provider settings={settings}>
                <App/>
           </Provider> 
        );
    }
}

